/* eslint-disable import/no-anonymous-default-export */
export default {
  "field.name": "Name",
  "field.description": "Beschreibung",
  "field.status": "Status",
  "field.created_at": "Erstellt am",
  "field.created_by": "Erstellt von",
  "field.updated_at": "Aktualisiert am",
  "field.updated_by": "Aktualisiert von",
  "field.revision": "Revision",
  "field.active.true": "Aktiv",
  "field.active.false": "Inaktiv",
  "field.search": "Suchen",
};
